import { FallbackErrorBoundary } from "@/components/FallbackErrorBoundary";
import { ListContainer } from "@/components/layout/ListContainer";
import { useActiveProject } from "@/features/project/ActiveProject";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { OrderItem } from "./OrderItem";
import { getNonDraftOrdersIds } from "./utils";

interface OrdersProps {
  editable?: boolean;
}
export const Orders = ({ editable }: OrdersProps) => {
  const { opportunity } = useActiveProject();

  const orderIds = getNonDraftOrdersIds(opportunity);

  if (!hasItems(orderIds)) {
    return <Text>{t("prompt.no_orders")}</Text>;
  }

  return (
    <div>
      <ListContainer>
        {orderIds.map((orderId) => (
          <FallbackErrorBoundary
            key={orderId}
            errorMessage={`Failed to load order ${orderId}`}
          >
            <OrderItem
              key={orderId}
              opportunityId={opportunity?.id}
              orderId={orderId}
              editable={editable}
            />
          </FallbackErrorBoundary>
        ))}
      </ListContainer>
    </div>
  );
};
